import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { IInitialState } from '../../../../reduxService';
import { useAppDispatch, useAppSelector } from '../../../../reduxService/hooks';
import { IProjectResultResponse } from '../../../MACRA_1/api/IApiResponse';
import { getActionByProjectType } from '../../../actionMap';
import LogoMaccaferri from '../../../images/LogoMaccaferri.svg';
import LogoMacRADesign from '../../../images/MacRA-Design_LOGO_negativo.png';
import { endpoint } from '../../../pages';
import { isAdminUser } from '../../../store/user/utils';
import BackofficeButton from './BackofficeButton/BackofficeButton';
import Breadcrumb from './Breadcrumb/Breadcrumb';
import ExportButton from './ExportButton/ExportButton';
import './Header.scss';
import LanguageButton from './LanguageButton/LanguageButton';
import NewButton from './NewButton/NewButton';
import OpenButton from './OpenButton/OpenButton';
import RunButton from './RunButton/RunButton';
import SaveButton from './SaveButton/SaveButton';
import UserButton from './UserButton/UserButton';
import HelpButton from './HelpButton/HelpButton';

const Header = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [allButtonVisible, setAllButtonVisible] = React.useState<boolean>();
    const { selectResults, cleanResults } = getActionByProjectType();

    const results: IInitialState<IProjectResultResponse> = useAppSelector(selectResults as any); //TODO aggiungi macra2
    const location = useLocation();

    React.useEffect(() => {
        if (location.pathname.includes(endpoint.designCondition)) setAllButtonVisible(true);
        else setAllButtonVisible(false);
    }, []);

    const handleGotoHome = () => {
        dispatch(cleanResults());
        navigate(endpoint.home);
    };

    return (
        <header id='HeaderMacra1'>
            <div className='head'>
                <div className='leftHead'>
                    <img className='cursor-pointer logoMacra' src={LogoMacRADesign} alt='Maccaferri logo header' onClick={handleGotoHome} />
                </div>
                <a className='backToHub' href={process.env.EDESIGN_PORTAL_URL}>
                    {t('header_back_to_hub')}
                </a>
                <img className='logoMaccaferri' src={LogoMaccaferri} alt='Logo Maccaferri' />
            </div>
            <nav className='menu'>
                <div>
                    {allButtonVisible && <NewButton className='btn' />}
                    <OpenButton className='btn' />
                    {allButtonVisible && (
                        <>
                            <SaveButton className='btn' />
                            {results.data && <ExportButton className='btn' />}
                        </>
                    )}
                    <LanguageButton className='btn' />
                    <HelpButton className='btn' />
                </div>
                <div className='d-flex'>
                    <UserButton />
                    {allButtonVisible && <RunButton />}
                    {location.pathname.endsWith(endpoint.home) && isAdminUser() && <BackofficeButton className='btn' />}
                </div>
            </nav>
            <div className='bg-color'>
                <Breadcrumb />
            </div>
        </header>
    );
};
export default Header;
